@if (isOpen) {
    <div>
        <div class="grid-container md:hide">
            <div class="g-12 p-36:b md:p-48:b lg:p-72:b">
                <app-order-summary [state]="query.state$ | async"></app-order-summary>
            </div>
        </div>
        @if (showInvoiceNotice) {
            <p class="fs:xs">Es wird zur Schadenregulierung zwingend eine Originalrechnung mit MwSt. benötigt.</p>
        }
        <form
            [formGroup]="form"
            (submit)="submit()"
        >
            <div class="grid-container vertical-gutter-sm md:vertical-gutter-md lg:vertical-gutter-lg">
                @if (product().orderConfig.requiresMedicalData) {
                    <div class="g-12 p-12 md:p-16 lg:p-24 fs:xs bg:grey-5 br-3">
                        <app-collapsible-checkbox
                            label="Gesundheitsdaten"
                            formControlName="medicalData"
                        >
                            Für deine Gesundheitsdaten, die die astra Versicherung AG zum Zwecke der Angebotserstellung,
                            Begründung und Durchführung des Versicherungsvertrages erhebt, speichert und nutzt, benötigt
                            die astra Versicherung AG deine Einwilligung in die Erhebung und Verwendung von
                            Gesundheitsdaten und Schweigepflicht&shy;entbindungs&shy;erklärung. <br /><br />Ich habe die
                            <a
                                href="assets/documents/Einwilligung_Verwendung_Gesundheitsdaten.pdf"
                                target="_blank"
                                rel="norefferrer noopener"
                                title="Einwilligung in die Erhebung und Verwendung von Gesundheitsdaten und Schweigepflicht&shy;entbindungs&shy;erklärung"
                                >Einwilligung in die Erhebung und Verwendung von Gesundheitsdaten und
                                Schweigepflicht&shy;entbindungs&shy;erklärung (PDF)</a
                            >
                            gelesen, gespeichert und erteile die dort nachgefragten Einwilligungen und
                            Schweigepflicht&shy;entbindungs&shy;erklärungen.
                        </app-collapsible-checkbox>
                    </div>
                }
                <div class="g-12 p-12 md:p-16 lg:p-24 fs:xs bg:grey-5 br-3">
                    <app-collapsible-checkbox
                        label="Vertragsunterlagen"
                        formControlName="tos"
                    >
                        Ich bestätige, dass ich das
                        <a
                            [href]="'/assets/documents/' + product().presentation?.docIPIDUrl"
                            target="_blank"
                            rel="noreferrer noopener"
                            title="Informationsblatt zu Versicherungsprodukten (PDF)"
                            >Informationsblatt zu Versicherungsprodukten (PDF)</a
                        >, die
                        <a
                            [href]="'/assets/documents/' + product().presentation?.docAVBUrl"
                            target="_blank"
                            rel="noreferrer noopener"
                            title="Allgemeine Versicherungsbedingungen (PDF)"
                            >Versicherungsbedingungen (PDF)</a
                        >{{
                            showConsultationProtocol() || product().presentation.docAnzeigepflichtUrl
                                ? ', die'
                                : ' und die'
                        }}
                        <a
                            [href]="'/assets/documents/' + product().presentation?.docAddInfoUrl"
                            target="_blank"
                            rel="noreferrer noopener"
                            title="Weitere Kundeninformationen (PDF)"
                            >weiteren Kundeninformationen (PDF)</a
                        >
                        mit Hinweisen zum Widerrufsrecht{{
                            showConsultationProtocol()
                                ? product().presentation.docAnzeigepflichtUrl
                                    ? ', das'
                                    : ' und das'
                                : ''
                        }}
                        @if (showConsultationProtocol()) {
                            <button
                                class="btn-link"
                                type="button"
                                (click)="downloadConsultationProtocol()"
                                aria-label="Download Beratungsprotokoll"
                            >
                                Beratungsprotokoll (PDF)
                            </button>
                        }
                        @if (product().presentation.docAnzeigepflichtUrl) {
                            und das
                            <a
                                [href]="'/assets/documents/' + product().presentation.docAnzeigepflichtUrl"
                                target="_blank"
                                rel="noreferrer noopener"
                                title="Informationsblatt zu Obliegenheiten und Anzeigepflicht (PDF)"
                            >
                                Informationsblatt zu Obliegenheiten und Anzeigepflicht (PDF)
                            </a>
                        }
                        gelesen und gespeichert habe. Ich stimme zu, dass der Versicherungsschutz vor dem Ende der
                        Widerrufsfrist beginnt.
                    </app-collapsible-checkbox>
                </div>
                @if (product().orderConfig.requiresNoPriorDefect) {
                    <div class="g-12 p-12 md:p-16 lg:p-24 fs:xs bg:grey-5 br-3">
                        <app-collapsible-checkbox
                            label="Keine Defekte vor Abschluss"
                            formControlName="noPriorDefect"
                        >
                            Ich bestätige, dass beim Abschluss der Versicherung keinerlei Defekte oder Schäden an dem
                            versicherten Gerät bzw. den versicherten Geräten vorliegen.
                        </app-collapsible-checkbox>
                    </div>
                }
                <p class="g-12 fs:xs">
                    Informationen zur Verarbeitung Deiner Daten findest Du in unseren
                    <a
                        routerLink="/datenschutz"
                        target="_blank"
                        title="Datenschutzerklärung in neuem Fenster öffnen"
                        >Datenschutz­bestimmungen</a
                    >.
                </p>
                <div class="g-12 fs:xs">
                    <input
                        type="checkbox"
                        id="confirm-contact-me"
                        formControlName="contact"
                    />
                    <label
                        class="p-12:b md:p-16:b lg:p-24:b"
                        for="confirm-contact-me"
                    >
                        <span class="fw:bold">
                            Ich bin damit einverstanden, dass die astra Versicherung AG mich per E-Mail über eigene
                            Versicherungsprodukte sowie allgemeine Themen rund um Tipps zur Gesundheit, Reisen uvm. per
                            E-Mail informieren darf. <br /><br />Ich kann diese Einwilligung jederzeit widerrufen.
                        </span>
                    </label>
                </div>
            </div>
            @if (product().orderConfig.showDiscountInput) {
                <div class="grid-container -end p-12:b md:p-16:b lg:p-24:b">
                    <div class="g-12 xs:g-8 lg:g-6 form-control">
                        <label
                            for="discount-code-input"
                            formControlName="discountCode"
                            appReactiveLabel
                        >
                            Rabattcode (falls vorhanden)
                        </label>
                        <input
                            id="discount-code-input"
                            type="text"
                            placeholder="Rabattcode (falls vorhanden)"
                            formControlName="discountCode"
                            [ngClass]="{ 'force-valid': discountMultiplier != 1 }"
                        />
                    </div>
                </div>
                <div class="grid-container p-12:b md:p-16:b lg:p-24:b product-price-display">
                    <div class="g-6">
                        @if (discountMultiplier == 1) {
                            <label>Dein Beitrag:</label>
                        }
                        @if (discountMultiplier != 1) {
                            <label>
                                Dein Beitrag (inkl. {{ (1 - discountMultiplier) * 100 | number: '1.0-0' }}% Rabatt):
                            </label>
                        }
                    </div>
                    <div class="g-12 align:r">
                        <span class="h4 product-hint">
                            {{ insuranceType().settlementPeriod == 'year' ? 'Jährlich' : 'Monatlich' }}
                        </span>
                        @if (priceService.price() * discountMultiplier; as price) {
                            <app-display-price [price]="price"></app-display-price>
                        }
                        <span
                            class="product-tax-details"
                            [innerHTML]="product().orderConfig.taxInfo"
                        ></span>
                    </div>
                </div>
            }
            <app-required-info></app-required-info>
            <div class="grid-container p-12:t md:p-16:t lg:p-24:t">
                <div class="g-12 md:g-4">
                    <button
                        type="button"
                        class="button -dark"
                        (click)="prev.emit({})"
                    >
                        Zurück
                    </button>
                </div>
                <div class="g-12 md:hide">&nbsp;</div>
                <div class="g-12 md:g-8 relative">
                    @if (form.invalid || someStepsInvalid || (orderService.requestPending$ | async)) {
                        <button
                            type="submit"
                            [disabled]="form.invalid || someStepsInvalid || (orderService.requestPending$ | async)"
                            ctrlTooltip
                            [ctrlTooltipConfig]="{ position: 'center-top', offsetY: 12 }"
                        >
                            Kostenpflichtig abschließen
                            <ctrl-tooltip class="invalid-tooltip">
                                {{
                                    (orderService.requestPending$ | async)
                                        ? 'Deine Anfrage wird bearbeitet, bitte habe einen Moment Geduld.'
                                        : someStepsInvalid
                                          ? 'Bitte überprüfe deine gesamten Angaben.'
                                          : 'Bitte bestätige alle grau hinterlegten Aussagen.'
                                }}
                            </ctrl-tooltip>
                        </button>
                    } @else {
                        <button type="submit">Kostenpflichtig abschließen</button>
                    }
                </div>
            </div>
        </form>
    </div>
}
